import { connect } from 'react-redux'
import { fetchInspection } from '../../actions/inspections'
import { goBack } from 'react-router-redux'
import get from 'lodash/get'

import ServicingImages from '../../components/servicings/servicing-images'

function mapStateToProps (state, { params: { inspectionId } }) {
  const servicing = get(state, `inspections.${inspectionId}`)
  if (!servicing) return { loading: true }

  return {
    servicing,
    modalTitle: 'Before/After Images',
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { inspectionId } = ownProps.params
  dispatch(fetchInspection(inspectionId))

  return {
    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingImages)



// WEBPACK FOOTER //
// ./src/containers/inspections/inspection-images-container.js